import {IPhoneNumber} from "@/models/IPhoneNumber";

export const formatPhoneNumberWithSpaces = (phone: string): string => {
  let phoneSpaces: string = "";
  if (phone && phone !== "") {
    phone = phone.replace(/ /g, ""); // reset the spaces
    const phoneSpacesArr: string[]|null = phone.match(/.{1,3}/g);
    phoneSpaces = phoneSpacesArr ? phoneSpacesArr.join(" ") : "";
  }

  return phoneSpaces;
};


export const getFormattedPhoneNumber = (toPhone: IPhoneNumber): string => {
  const phoneNumber = formatPhoneNumberWithSpaces(toPhone.number);
  if (phoneNumber !== "") {
    return `${toPhone.extension} ${phoneNumber}`;
  }

  return "";
};
